import React from 'react';
import PropTypes from 'prop-types';

import CardPartial from '../../common/CardPartial';
import GridSimple from '../../content/grid/GridSimple';

import useCharts from '../../../../hooks/useCharts';

function GridGenresV2({
  id, pathApi, title, 
  width, height = '100%',
  customReduceFormat = null,
  showTitle = false,
  showAll = true,
  hasPagination = false,
  className, gridStyle,
  rowWidth = 128,
  rowHeight = 160
}) {
  const [dataHook] = useCharts(id, pathApi, 100, 'CHART', customReduceFormat);
  
  const rowPadding = 4;
  const gap = 0;
  const lock = (dataHook && dataHook.items && id === dataHook.id);
  const data = (dataHook && dataHook.items && id === dataHook.id) ? dataHook.items : [];
  const nbVisible = Math.floor(width / rowWidth);
  const nbShowing = (showAll) ? data.length : Math.floor((width - ((nbVisible - 2) * gap)) / rowWidth);;

  return (!lock || (lock && data.length > 0) ) ? (
    <GridSimple
      key={`grid-genres-${title}-${data.length}`}
      title={title}
      data={data}
      height={height}
      className={className}
      gridClassName={'grid-list-genres'}
      gridStyle={{...gridStyle, gap, position: 'relative'}}
      hasPagination={hasPagination}
      pagLimit={nbShowing}
      element={ <CardPartial showTitle={showTitle} 
        style={{ width: rowWidth - (rowPadding * 2), height: rowHeight, padding: rowPadding }} 
      /> }
    />
  ) : null;
}

GridGenresV2.propTypes = {
  id: PropTypes.string.isRequired,
  pathApi: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.any,  
  customReduceFormat: PropTypes.func,
  showTitle: PropTypes.bool,
  showAll: PropTypes.bool,
  hasPagination: PropTypes.bool,
  gridStyle: PropTypes.object,
  className: PropTypes.string,
  rowWidth: PropTypes.number,
  rowHeight: PropTypes.number
}

export default GridGenresV2;
